import { observable, action } from "mobx";
import { observer } from "mobx-react";
import { ALERT_BOX_COLOR } from "Static/constant";
import { ReactComponent as TickIcon } from "Assets/svg/tick.svg";
import { ReactComponent as ErrorIcon } from "Assets/svg/error.svg";
import { ReactComponent as WarningIcon } from "Assets/svg/warning.svg";
import React from "react";

class AlertStore {
  @observable alertMessage = "";
  @observable showStatusPopup = false;
  @observable bgcolor = ALERT_BOX_COLOR.DANGER;
  @observable textColor = ALERT_BOX_COLOR.ERROR_TEXT_COLOR;

  @observable isSuccess = false;
  @observable isError = false;

  @action
  setAlertMessage = (message = "", msgType = "") => {
    this.alertMessage = message;
    this.isSuccess = false;
    this.isError = false;

    switch (msgType.toLowerCase()) {
      case "success":
        this.bgcolor = ALERT_BOX_COLOR.SUCCESS;
        this.isSuccess = true;
        break;
      case "error":
        this.bgcolor = ALERT_BOX_COLOR.WARNING;
        this.isError = true;
        this.textColor = ALERT_BOX_COLOR.ERROR_TEXT_COLOR;
        break;
      default:
        this.bgcolor = ALERT_BOX_COLOR.DANGER;
        break;
    }
    this.setShowStatusPopup(true);
  };

  @action
  setShowStatusPopup = (val = false) => {
    this.showStatusPopup = val;
  };
}

const alertStore = new AlertStore();

const AlertBox = observer(() => {
  return (
    alertStore.showStatusPopup && (
      <div className="error-container">
        <div
          className="error-box"
          style={{
            backgroundColor: alertStore.bgcolor,
            color: alertStore.textColor
          }}
        >
          {alertStore.isError && (
            <span className="svgIcon crossIcon">
              <ErrorIcon />
            </span>
          )}
          {alertStore.isSuccess && (
            <span className="svgIcon">
              <TickIcon />
            </span>
          )}

          <span>{alertStore.alertMessage}</span>
        </div>
      </div>
    )
  );
});

export { AlertBox, alertStore };
export default AlertBox;
